import { Layout, Row, Space, ConfigProvider } from 'antd'
import styled from 'styled-components'

import Profile from './components/profile'
import Pages from './components/pages'
const { Content, Footer } = Layout

const Container = styled(Content)`
  max-width: 88%;
  margin: 0 auto;

  @media only screen and (max-width: 1024px) {
    max-width: 98%;
  }

  @media only screen and (max-width: 768px) {
    max-width: 96%;
  }
`

function App() {
  return (
    <ConfigProvider theme={{ token: { borderRadius: 2 } }}>
      {/* <Space>
      <div className='art-landing'></div>
      <div className='science-landding'></div>
    </Space>


    <div className='center-landing'>
      <h1>PATARA TRIRAT</h1>
      <h2>Art & Science</h2>
    </div> */}
      <Container>
        <Content>
          <br />
          <br />
          <Row gutter={16}>
            <Profile />
            <Pages />
          </Row>
          <br />
          <br />
        </Content>
        <Footer style={{ textAlign: 'center', background: 'transparent' }}>
          PATARA TRIRAT &copy; 2024
        </Footer>
        <br />
      </Container>
    </ConfigProvider>
  );
}

export default App;
